import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DoramaCard from '../components/DoramaCard';
import { useGetHistoryQuery } from '../services/historyApi';
import styles from '../css/History.module.css';

const History = () => {
  const [filterPeriod, setFilterPeriod] = useState('all');

  const isAuthenticated = useSelector(s => s.auth.isAuthenticated);

  const { data, isLoading } = useGetHistoryQuery({}, {
    skip: !isAuthenticated,
    refetchOnMountOrArgChange: true,
  });

  const allItems = data?.data ?? [];
  const total = data?.meta?.total ?? 0;

  const filterItems = () => {
    const now = new Date();
    const weekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    const monthAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);

    return allItems.filter(item => {
      const watchedDate = new Date(item.last_watched_at);
      if (filterPeriod === 'week') return watchedDate >= weekAgo;
      if (filterPeriod === 'month') return watchedDate >= monthAgo;
      return true;
    });
  };

  const filteredItems = filterItems();

  if (!isAuthenticated) {
    return (
      <div className={styles.historyPage}>
        <div className={styles.emptyState}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
            <polyline points="10 17 15 12 10 7"/>
            <line x1="15" y1="12" x2="3" y2="12"/>
          </svg>
          <p>Войдите в аккаунт, чтобы видеть историю просмотров</p>
          <Link to="/auth/login" className={styles.loginButton}>
            Войти
          </Link>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className={styles.historyPage}>
        <p>Загрузка...</p>
      </div>
    );
  }

  return (
    <div className={styles.historyPage}>
      <Link to="/profile" className={styles.backButton}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M19 12H5M12 19l-7-7 7-7"/>
        </svg>
        Назад к профилю
      </Link>

      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <h1 className={styles.title}>История просмотров</h1>
          <p className={styles.subtitle}>
            Всего просмотрено: <span className={styles.count}>{total}</span> дорам
          </p>
        </div>

        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            Период
          </label>
          <select
            value={filterPeriod}
            onChange={(e) => setFilterPeriod(e.target.value)}
            className={styles.filterSelect}
          >
            <option value="all">Всё время</option>
            <option value="week">За неделю</option>
            <option value="month">За месяц</option>
          </select>
        </div>
      </div>

      {filteredItems.length > 0 ? (
        <div className={styles.dramasGrid}>
          {filteredItems.map(item => (
            <div key={item.material_id} className={styles.dramaWrapper}>
              <DoramaCard
                id={item.material_id}
                slug={item.slug}
                slug_id={item.slug_id}
                image={
                  item.poster_url
                    ? `https://doramahype.ru/uploads/posters/${item.poster_url}`
                    : null
                }
                title={item.title}
                year={item.year}
                genres={item.genres ?? []}
              />
              <div className={styles.progressInfo}>
                <div className={styles.progressBar}>
                  <div
                    className={styles.progressFill}
                    style={{
                      width: item.episodes_count
                        ? `${Math.min((item.episodes_watched / item.episodes_count) * 100, 100)}%`
                        : '100%',
                    }}
                  />
                </div>
                <p className={styles.progressText}>
                  {item.episodes_count
                    ? `${item.episodes_watched} / ${item.episodes_count} серий`
                    : 'Просмотрено'}
                </p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.emptyState}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          <p>
            {total > 0
              ? 'За выбранный период просмотров не найдено'
              : 'История просмотров пуста'}
          </p>
        </div>
      )}
    </div>
  );
};

export default History;
